
import { Component, Vue } from 'vue-property-decorator'
import { ImagePreview } from 'vant';

type RoomDataInfo = {
  userSource?: number;
  enterpriseName?: string;
  enterpriseCode?: string;
  base64BusinessLicense?: string;
  mobile?: string;
  title?: string;
}

@Component
export default class detailComp extends Vue {
  roomDataInfo: RoomDataInfo = {};
  isShow = true;

  get roomData() {
    return this.$store.getters['getRoomDetail/getRoomDetail'];
  }

  get isEnterprise() {
    return this.roomDataInfo.userSource === 1 || this.roomDataInfo.userSource === 3;
  }

  get mobileDesensitization() {
    const mobile = this.roomDataInfo.mobile || '';
    if (mobile.length !== 11) return mobile;
    return mobile.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
  }

  get businessLicense() {
    return 'data:image/jpeg;base64,' + (this.roomDataInfo.base64BusinessLicense || '');
  }

  getDetailInfo(roomData: RoomDataInfo) {
    this.roomDataInfo = roomData;
    let sessionData =  JSON.parse(sessionStorage.getItem('roomData') || '{}');
   this.roomDataInfo.title=sessionData?.title || '';
    this.isShow = true;
  }

  handleClick() {
    this.isShow = !this.isShow;
  }

  previewImage() {
    ImagePreview({
      images: [this.businessLicense],
      showIndex: false,
      closeOnPopstate: true,
    });
  }
}

